module.exports = __webpack_public_path__ + "static/media/cx.073c87bc.svg";